import type { JSX } from "react";
import { useMemo } from "react";
import { useSceneStore } from "@/state/useSceneStore";

const countFor = (q: "low" | "med" | "high"): number =>
  q === "low" ? 0 : q === "med" ? 700 : 1400;

const buildPositions = (count: number): Float32Array => {
  const arr = new Float32Array(count * 3);
  for (let i = 0; i < count; i += 1) {
    arr[i * 3] = (Math.random() - 0.5) * 2.2;
    arr[i * 3 + 1] = Math.random() * 1.6;
    arr[i * 3 + 2] = (Math.random() - 0.5) * 2.2;
  }
  return arr;
};

export const DustField = (): JSX.Element | null => {
  const quality = useSceneStore((s) => s.quality);
  const count = countFor(quality);

  const positions = useMemo<Float32Array>(() => buildPositions(count), [count]);

  if (count === 0) return null;

  return (
    <points>
      <bufferGeometry>
        <bufferAttribute attach="attributes-position" args={[positions, 3]} />
      </bufferGeometry>
      <pointsMaterial
        size={0.0045}
        opacity={0.35}
        transparent
        depthWrite={false}
        sizeAttenuation
      />
    </points>
  );
};
